export const FeelSubscriptionEvents = {
    FEEL_SUBSCRIPTION_JOIN_SUCCESS: '[Feel Subscription] FEEL_SUBSCRIPTION_JOIN_SUCCESS',
    FEEL_SUBSCRIPTION_JOIN_NEEDS_LOGIN: '[Feel Subscription] FEEL_SUBSCRIPTION_JOIN_NEEDS_LOGIN',
    FEEL_SUBSCRIPTION_JOIN_ERROR: '[Feel Subscription] FEEL_SUBSCRIPTION_JOIN_ERROR',
};
